import React, {lazy, Suspense} from 'react'

const SpaceWebAppsLazy = lazy(() =>
    import('./SpaceWebApps')
)

const SpaceWebApps = props => (
    <Suspense fallback={null}>
        <SpaceWebAppsLazy {...props} />
    </Suspense>
)

export default SpaceWebApps
